import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSmallScreen } from 'utils/hooks';
import { appNotificationSelectors } from 'reducers';
import { notificationDeleted } from 'reducers/appNotification';
import { texts } from 'utils/languages/fr';

import * as icons from 'mdi-material-ui';
import { Snackbar, IconButton, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    notification: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.secondary.main,
    },
}));

const CustomNotification = () => {
    const classes = useStyles();
    const smallScreen = useSmallScreen();
    const dispatch = useDispatch();

    const notification = useSelector(appNotificationSelectors.getNotification);

    const [open, setOpen] = useState(false);

    const handleClose = useCallback(() => {
        dispatch(notificationDeleted());
        setOpen(false);
    }, [dispatch]);

    useEffect(() => {
        if (notification.msgKey) {
            setOpen(true);
        }
    }, [notification]);

    if (notification.msgKey) {
        return (
            <Snackbar
                anchorOrigin={
                    smallScreen
                        ? {
                              vertical: 'top',
                              horizontal: 'center',
                          }
                        : {
                              vertical: 'top',
                              horizontal: 'right',
                          }
                }
                ContentProps={{
                    className: classes.notification,
                }}
                open={open}
                autoHideDuration={30000}
                onClose={handleClose}
                message={
                    <>
                        {texts[notification.msgKey].split('\n').map(line => (
                            <Typography key={line}>{line}</Typography>
                        ))}
                    </>
                }
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleClose}
                    >
                        <icons.Close fontSize="small" />
                    </IconButton>
                }
            />
        );
    }
    return null;
};

export default CustomNotification;
